import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
`;

const showLogin = keyframes`
from{
    opacity: 0;
}
to{
    opacity: 1;
}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  place-content: center;
  width: 100%;
  animation: ${showLogin} 2s;
`;

export const Column = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
  min-width: 300px;
  height: 100vh;
  padding: 10vh 0 10% 0;

  img {
    width: 100%;
  }

  form {
    margin-top: 100px;
    width: 100%;
    text-align: center;
  }
`;
